export default __webpack_public_path__ + "static/media/redirect-to-top-icon.24a3e484.svg";